import { css } from "@emotion/react";

export const styErrorView = css`
  widht: 100vw;
  height: 100vh;
  position: relative;

  > div {
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    button {
      padding: 8px 16px;
    }
  }
`;
